/** @format */

import {styled} from '@mui/material/styles';
import Menu, {MenuProps} from '@mui/material/Menu';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({theme}) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: '#202020',
    background: '#E3E3E3',
    '& .MuiMenu-list': {
      '&:hover': {background: '#E3E3E3'},
    },
    '& .MuiMenuItem-root': {
      padding: theme.spacing(3, 2, 3, 8),
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {},
      '&:hover': {background: '#F1F1F1'},
      '&:first-of-type': {
        padding: theme.spacing(3, 2),
        borderBottom: '1px solid #8B8B8B',
      },
      '&:last-of-type': {
        padding: theme.spacing(3, 2),
        borderTop: '1px solid #8B8B8B',
      },
    },
  },
}));

export {StyledMenu};
